import TalkJS from 'talkjs';
import DialogService from './DialogService';
import { ChatUser } from './types/chat';

export * from './types/chat';

enum MessageEventType {
    PROFILE_SHARING_REQUEST = 'PROFILE_SHARING_REQUEST',
    PROFILE_SHARING_RESPONSE = 'PROFILE_SHARING_RESPONSE',
}

export enum ProfileSharingStatus {
    None,
    Active,
    Pending,
    Rejected,
}

interface MessageEvent {
    type: MessageEventType;
    payload: any;
}

class TalkJSService {
    static handleEvents(
        session: TalkJS.Session,
        chatUser: ChatUser,
        message: TalkJS.Message,
        events: MessageEvent[]
    ) {
        for (let event of events) {
            TalkJSService.handleEvent(session, chatUser, message, event);
        }
    }

    static handleEvent(
        session: TalkJS.Session,
        chatUser: ChatUser,
        message: TalkJS.Message,
        messageEvent: MessageEvent
    ) {
        const conversation: TalkJS.ConversationBuilder = session.getOrCreateConversation(
            message.conversation.id
        );

        if (messageEvent.type === MessageEventType.PROFILE_SHARING_REQUEST) {
            DialogService.openProfileSharingConfirmationDialog(
                message.sender!!.name,
                messageEvent.payload,
                (profileSharingConsent: object) => {
                    TalkJSService.sendPayloadMessage(
                        conversation,
                        `${chatUser.displayName} accepted the request of sharing the profile!`,
                        {
                            events: JSON.stringify([
                                {
                                    type: MessageEventType.PROFILE_SHARING_RESPONSE,
                                    payload: profileSharingConsent,
                                },
                            ]),
                        }
                    );
                },
                (profileSharingConsent: object) => {
                    TalkJSService.sendPayloadMessage(
                        conversation,
                        `${chatUser.displayName} rejected the sharing of the profile!`,
                        {
                            events: JSON.stringify([
                                {
                                    type: MessageEventType.PROFILE_SHARING_RESPONSE,
                                    payload: profileSharingConsent,
                                },
                            ]),
                        }
                    );
                }
            );
        }
    }

    static sendPayloadMessage(
        conversation: TalkJS.ConversationBuilder,
        message: string,
        custom: TalkJS.CustomData
    ) {
        conversation.sendMessage(`\`\`\`${message}\`\`\``, {
            custom: custom,
        });
    }

    static getSession(user: ChatUser) {
        const talkJSUser = new TalkJS.User(user.id);

        return new TalkJS.Session({
            appId: process.env.VUE_APP_TALKJS_APPID,
            me: talkJSUser,
            signature: user.signature,
        });
    }
}

export default TalkJSService;
